import React from 'react';
import { BreadcrumbsProps } from './ListingBreadcrumbs.types';
import { Breadcrumbs } from '@blueprint/ui';

import { BreadCrumbsContainer } from './ListingBreadcrumbs.styles';
import { trackBreadcrumbLinkClick } from './ListingBreadcrumbs.tracking';

const ListingBreadcrumbs = ({ data }: BreadcrumbsProps) => {
    if (!data) {
        return null;
    }

    const breadcrumbs = data.map((breadcrumb) => {
        return {
            label: breadcrumb.label || null,
            tracking: breadcrumb.tracking || null,
            uri: breadcrumb.uri || null,
            i18nLabelKey: breadcrumb.i18nLabelKey || null,
            noAppend: breadcrumb.noAppend || null
        };
    });

    return (
        <BreadCrumbsContainer data-testid="breadcrumb-container">
            <Breadcrumbs
                data-testid="listing-breadcrumbs"
                data={breadcrumbs}
                clickEvent={(action: string | null, value: number) => {
                    trackBreadcrumbLinkClick(action, value);
                }}
            />
        </BreadCrumbsContainer>
    );
};

export default ListingBreadcrumbs;
